import {UserAccess} from './types';

export function getUserAccess(entity: any, {ownerId, userId}: {ownerId: number; userId: number}): UserAccess {
  return ownerId === userId
    ? UserAccess.Creator
    : entity.can_update_basic || entity.canUpdateBasic
      ? UserAccess.Editor
      : entity.can_view || entity.canView
        ? UserAccess.Viewer
        : UserAccess.None;
}
